import TileLayer from '@arcgis/core/layers/TileLayer';
import VectorTileLayer from '@arcgis/core/layers/VectorTileLayer';
import { GISServiceTypes } from '../gisServicesTypes';
import { LayerLoader, ensureLoadedLayerArray } from './LayerLoader';
import { resolveAdminOpacity } from './defaultLayerLoader';

function isVectorTileServiceUrl(url: string | undefined): boolean {
  return (url || '').toLowerCase().includes('/vectortileserver');
}

function withToken(url: string, token: string | undefined): string {
  if (!token) return url;
  const delimiter = url.includes('?') ? '&' : '?';
  return `${url}${delimiter}token=${token}`;
}

/**
 * Dedicated loader for ArcGIS tiled services:
 * - Vector tile services (`/VectorTileServer`)
 * - Cached map tile services (`/MapServer`)
 *
 * Keeping this separate from defaultLayerLoader makes tile behavior easier to
 * discover and adjust.
 */
export const tileLayerLoader: LayerLoader = {
  shouldUseLoader(service) {
    return service.service_type === GISServiceTypes.tileVector;
  },

  async load(service) {
    const adminOpacity = resolveAdminOpacity(service);
    const requestUrl = withToken(service.gis_service_url, service.token);
    const isVectorTile = isVectorTileServiceUrl(service.gis_service_url);

    const layer = isVectorTile
      ? new VectorTileLayer({
          id: service.gisLayerID,
          url: requestUrl,
          visible: service.auto_checked || false,
          ...(adminOpacity !== undefined ? { opacity: adminOpacity } : {}),
        })
      : new TileLayer({
          id: service.gisLayerID,
          url: requestUrl,
          visible: service.auto_checked || false,
          ...(adminOpacity !== undefined ? { opacity: adminOpacity } : {}),
        });

    await layer.load();
    return ensureLoadedLayerArray(layer);
  },
};
